import React from 'react';
import junoCongrats from "../assets/juno-congrats.png";
import '../App.css';

const CongratulationScreen = ({ points }) => {
  return (
    <div className="congratulation-screen">
      <div className="star">⭐</div>
      <h2>You're a super star.</h2>
      <h3>Well done!</h3>
      <p>You earned {points} {points === 1 ? 'star' : 'stars'}!</p>
      <img src={junoCongrats} alt="Cute elephant" className="congrats-mascot" />
    </div>
  );
};

export default CongratulationScreen;